import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const WEEKDAYS = [[6, "Sun"], [0, "Mon"], [1, "Tue"], [2, "Wed"], [3, "Thu"], [4, "Fri"], [5, "Sat"]];

export function WeekdayPicker({ value, onChange }) {
  const list = value || [];
  return (
    <div className="flex flex-wrap gap-2" data-testid="field-weekdays">
      {WEEKDAYS.map(([d, l]) => (
        <button key={d} type="button" onClick={() => onChange(list.includes(d) ? list.filter((x) => x !== d) : [...list, d])} data-testid={`weekday-${l.toLowerCase()}`}
          className={`chip btn-press border px-3 py-1.5 ${list.includes(d) ? "border-[#0052FF] bg-[#0052FF] text-white" : "border-slate-200 bg-white text-slate-600"}`}>{l}</button>
      ))}
    </div>
  );
}

export function TimesEditor({ value, onChange }) {
  const list = value || [];
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="field-times">
      {list.map((t, i) => (
        <div key={i} className="flex items-center gap-1">
          <Input type="time" value={t} onChange={(e) => onChange(list.map((x, j) => (j === i ? e.target.value : x)))} className="h-9 w-32" data-testid={`time-input-${i}`} />
          <Button type="button" size="icon" variant="ghost" className="h-8 w-8" onClick={() => onChange(list.filter((_, j) => j !== i))} data-testid={`time-remove-${i}`}><X className="h-4 w-4" /></Button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" className="rounded-full" onClick={() => onChange([...list, ""])} data-testid="time-add-button"><Plus className="h-4 w-4" />Add time</Button>
    </div>
  );
}
